import { Component, OnInit, ChangeDetectionStrategy, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { TextDialogComponent } from '../../../../text-dialog/text-dialog.component';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ApiService, UtilsService } from 'src/app/services';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-product-task-design-link-detail-dialog',
  imports: [ReactiveFormsModule, MatFormFieldModule, MatIconModule, MatDialogModule, MatInputModule, MatButtonModule],
  templateUrl: './product-task-design-link-detail-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './product-task-design-link-detail-dialog.component.css',
})
export class ProductTaskDesignLinkDetailDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<TextDialogComponent>>(MatDialogRef);
  data = inject<{
    product_task_design_link_id: number | undefined;
    product_task_id: number;
  }>(MAT_DIALOG_DATA);
  private fb = inject(FormBuilder);
  private api = inject(ApiService);
  private utils = inject(UtilsService);

  form: FormGroup;

  constructor() {
    this.form = this.fb.group({
      id: null,
      product_task_id: ['', Validators.compose([Validators.required])],
      link: ['', Validators.compose([Validators.required, Validators.pattern(this.utils.urlRegex())])],
      comment: ['', Validators.compose([])],
    });
  }

  ngOnInit(): void {
    if (this.data.product_task_design_link_id) {
      this.initFilledForm();
    } else {
      this.initBlankForm();
    }
  }

  save(): void {
    if (this.form.value.id != null) {
      const taskDesignLink = this.form.value;

      this.api.updateProductTaskDesignLink(taskDesignLink).subscribe((data: any) => {
        this.dialogRef.close(data);
      });
    } else {
      const taskDesignLink = {
        product_task_id: this.form.value.product_task_id,
        link: this.form.value.link,
        comment: this.form.value.comment,
      };

      this.api.createProductTaskDesignLink(taskDesignLink).subscribe((data: any) => {
        this.dialogRef.close(data);
      });
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  private initBlankForm(): void {
    this.form.patchValue({
      id: null,
      product_task_id: this.data.product_task_id,
      link: '',
      comment: '',
    });
  }

  private initFilledForm(): void {
    if (!this.data.product_task_design_link_id) {
      this.dialogRef.close();
      return;
    }

    this.api.getProductTaskDesignLink({ id: this.data.product_task_design_link_id }).subscribe({
      next: data => {
        this.form.patchValue({
          id: data.id,
          product_task_id: this.data.product_task_id,
          link: data.link,
          comment: data.comment,
        });
      },
      error: err => {
        this.dialogRef.close();
      },
    });
  }
}
